import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { DocumentMode } from '../_enums/DocumentMode.enum';
import { IDocumentConfiguration } from '../_interfaces/DocumentConfiguration';
import { IEntityConfiguration } from '../_interfaces/IEntityConfiguration';
import { DocumentUploaderService } from 'src/modules/shared/services/Document-Uploader.service';

@Component({
  selector: 'app-general-document-uploader',
  templateUrl: './general-document-uploader.component.html',
  styleUrls: ['./general-document-uploader.component.scss']
})
export class GeneralDocumentUploaderComponent implements OnInit, OnChanges {

  //#region [Inputs]
  @Input() Mode: DocumentMode;
  @Input() DocConfigsList: IDocumentConfiguration[];
  @Input() EntityConfigration: IEntityConfiguration;
  // not a normal case
  // @Input() IsMaximumOverride: boolean = false;
  @Input() NumberOfElement: number = 1;
  //#endregion

  //#region [Outputs]
  @Output() DocumentChanged: EventEmitter<IDocumentConfiguration> = new EventEmitter<IDocumentConfiguration>();
  @Output() StartUploading: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() Uploaded: EventEmitter<boolean> = new EventEmitter<boolean>();
//#endregion

  //#region [Variables]
  isDocumentConfigurationsHaveFiles: boolean = false;
    // document modes
    newMode: DocumentMode = DocumentMode.new;
    editMode: DocumentMode = DocumentMode.edit;
    readMode: DocumentMode = DocumentMode.read;
    //#endregion
    
  //#region [life cycle]  
  constructor(private documentUploaderService: DocumentUploaderService) {
  }
  ngOnInit() {
    this.isDocumentConfigurationsHaveFiles = 
    this.documentUploaderService.checkDocConfigsContainsFiles(this.DocConfigsList);
  }
  ngOnChanges(changes: SimpleChanges) {    
    if (changes && changes.DocConfigsList && changes.DocConfigsList.currentValue) { 
      this.isDocumentConfigurationsHaveFiles = 
      this.documentUploaderService.checkDocConfigsContainsFiles(changes.DocConfigsList.currentValue);
    }
  }
//#endregion

//#region [Output Events]
  docConfigsChange(value) { 
    this.DocumentChanged.emit(value);
  }
  docConfigsStartUploading(value) { 
    this.StartUploading.emit(value);
  }
  docConfigsUploaded(value) { 
    this.Uploaded.emit(value);
  }
  //#endregion

}